import React, { useEffect, useState } from "react";
import { Button, Container, Dropdown, Nav } from "react-bootstrap";
import {} from "bootstrap";
import Login from "../../templates/Auth/LoginTemp";
import axios from "axios";
import style from "./Header.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightFromBracket,
  faGear,
  faRocket,
  faStar,
  faUser,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  faCircleQuestion,
  faEnvelopeOpen,
} from "@fortawesome/free-regular-svg-icons";
import useForceUpdate from "use-force-update";
import { useNavigate } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import Profile from "../offCanvas/profile/Profile";
import AddYourSignature from "../offCanvas/addYourSignature/AddYourSignature";
import SignatureSetting from "../offCanvas/signatureSetting/SignatureSetting";
import lang from "../../../assets/lang/icons.json";
import ContactUs from "../contactUs/ContactUs";
import BodyLoading from "../Loading/BodyLoading";

export default function Header() {
  const forceUpdate = useForceUpdate();
  const [isLogin, SetLogin] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const Navigator = useNavigate();
  const [loading, setLoading] = useState(false);

  const [showProfile, setProfileShow] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [showAddSignature, setShowAddSignature] = useState(false);
  const [showSigSetting, setShowSigSetting] = useState(false);

  const handleProfileClose = () => setProfileShow(false);
  // const handleContactClose = () => setShowContact(false);
  const handleAddSignatureClose = () => setShowAddSignature(false);
  const handleSigSettingClose = () => setShowSigSetting(false);

  const handleShowProfile = (e) => {
    e.preventDefault();
    setProfileShow(true);
  };
  const handleShowAddSignature = (e) => {
    e.preventDefault();
    setShowAddSignature(true);
  };
  const handleShowContactUs = (e) => {
    e.preventDefault();
    setShowContact(true);
  };
  const handleShowSigSetting = (e) => {
    e.preventDefault();
    setShowSigSetting(true);
  };

  const LoginModel = (e) => {
    e.preventDefault();
    Navigator("/login", { replace: true });
  };

  const LogoutModel = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await axios.post("/logout");

      if (response.data.status === 200) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("user");
        localStorage.removeItem("image");
        setIsLoggedIn(false);
        SetLogin(false);
        forceUpdate();
        Navigator("/login", { replace: true });
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getLoginState = (Login) => {
    setIsLoggedIn(Login);
    forceUpdate();
    Navigator("/editor");
  };

  const showLogin = () => {
    if (isLogin && !localStorage.getItem("auth_token")) {
      return <Login checkLogin={getLoginState} />;
    } else {
      return "";
    }
  };

  const userEmail = () => {
    const responseString = localStorage.getItem("user");
    const response = JSON.parse(responseString);
    return response.email;
  };

  var check_auth = "";
  if (!localStorage.getItem("auth_token") && !isLoggedIn) {
    check_auth = (
      <Nav>
        <Button className="btn btn-outline-primary" onClick={LoginModel}>
          Login
        </Button>
      </Nav>
    );
  } else {
    check_auth = (
      <Nav>
        <Button className="btn btn-outline-primary" onClick={LogoutModel}>
          Logout
        </Button>
      </Nav>
    );
  }

  const showUsertoggle = () => {
    if (isLoggedIn || localStorage.getItem("auth_token")) {
      return (
        <Dropdown.Menu
          className=" px-3 py-2 border-0 shadow"
          style={{ margin: 0 }}
        >
          <Dropdown.Item
            as="button"
            className={`${style.dropdownItem} py-2`}
            onClick={handleShowProfile}
          >
            <FontAwesomeIcon icon={faUserCircle} className="me-2 " />
            Profile
          </Dropdown.Item>
          <span className="my-2 border w-100 d-block"></span>
          <Dropdown.Item
            as="button"
            className={`${style.dropdownItem} py-2`}
            onClick={handleShowAddSignature}
          >
            <FontAwesomeIcon icon={faEnvelopeOpen} className="me-2 " />
            Add To Your Email
          </Dropdown.Item>
          <Dropdown.Item
            as="button"
            className={`${style.dropdownItem} py-2`}
            onClick={handleShowSigSetting}
          >
            <FontAwesomeIcon icon={faGear} className="me-2 " />
            Signature Settings
          </Dropdown.Item>
          <span className="my-2 border w-100 d-block"></span>
          <Dropdown.Item as="button" className={`${style.dropdownItem} py-2`}>
            <FontAwesomeIcon icon={faCircleQuestion} className="me-2 " />
            Help Center
          </Dropdown.Item>
          <Dropdown.Item
            as="button"
            className={`${style.dropdownItem} py-2`}
            onClick={handleShowContactUs}
          >
            <FontAwesomeIcon icon={faRocket} className="me-2 " />
            Contact Us
          </Dropdown.Item>
          <span className="my-2 border w-100 d-block"></span>
          <span className="px-3 d-block text-secondary">{userEmail()}</span>
          <Dropdown.Item
            as="button"
            className={`${style.dropdownItem} py-2`}
            onClick={LogoutModel}
          >
            <FontAwesomeIcon icon={faArrowRightFromBracket} className="me-2 " />
            Logout
          </Dropdown.Item>
        </Dropdown.Menu>
      );
    } else {
      return (
        <Dropdown.Menu
          className="mt-4 me-4 px-4 py-2 border-0 shadow"
          style={{ margin: 0 }}
        >
          <Dropdown.Item className={`${style.dropdownItem} py-2`}>
            <FontAwesomeIcon icon={faCircleQuestion} className="me-2 " />
            Help Center
          </Dropdown.Item>
          <Dropdown.Item
            className={`${style.dropdownItem} py-2`}
            onClick={handleShowContactUs}
          >
            <FontAwesomeIcon icon={faRocket} className="me-2 " />
            Contact Us
          </Dropdown.Item>
          <span className="my-2 border w-100 d-block"></span>
          <Dropdown.Item
            className={`${style.dropdownItem} py-2`}
            onClick={LoginModel}
          >
            <FontAwesomeIcon icon={faArrowRightFromBracket} className="me-2 " />
            Login
          </Dropdown.Item>
        </Dropdown.Menu>
      );
    }
  };

  useEffect(() => {}, [isLogin, check_auth]);

  return (
    <>
      <Container fluid className={`${style.header}`}>
        {loading ? <BodyLoading /> : null}
        <div className={`${style.headerWrapper}`}>
          <div className="d-flex align-items-center">
            <div className={`${style.headerItems} ${style.headerLeft}`}>
              <div className={`${style.HeaderLogo}`}>
                <img
                  src={`${lang.headerLogo}`}
                  alt="WiseStamp a vcita company"
                  loading="lazy"
                  className={`${style.headerImg}`}
                />
              </div>
            </div>
            <div className={`${style.headerItems} ${style.headerCenter}`}></div>
            <div className={`${style.headerItems} ${style.headerRight}`}>
              {localStorage.getItem("auth_token") ? (
                <Button className={` btn-sm me-2  btn-secondary `}>
                  <FontAwesomeIcon icon={faStar} className="me-2" /> Upgrade Now
                </Button>
              ) : (
                ""
              )}

              {check_auth}
              {showLogin()}

              <Dropdown className={`${style.dropdown} ms-3`}>
                <Dropdown.Toggle
                  variant="light"
                  id="dropdown-basic"
                  style={{ borderRadius: "50%", border: " 1px solid silver" }}
                >
                  <FontAwesomeIcon icon={faUser} />
                </Dropdown.Toggle>

                {showUsertoggle()}
                {showContact ? (
                  <ContactUs closeContact={setShowContact} />
                ) : null}
              </Dropdown>

              <Offcanvas
                placement="end"
                show={showProfile}
                onHide={handleProfileClose}
                className={`${style.Offcanvas}`}
              >
                {<Profile />}
              </Offcanvas>

              <Offcanvas
                placement="end"
                show={showAddSignature}
                onHide={handleAddSignatureClose}
                className={`${style.Offcanvas}`}
              >
                {<AddYourSignature />}
              </Offcanvas>

              <Offcanvas
                placement="end"
                show={showSigSetting}
                onHide={handleSigSettingClose}
                className={`${style.Offcanvas}`}
              >
                {<SignatureSetting />}
              </Offcanvas>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
